var PRIMARY_COLORS = {
  primary: '#332E54',
  primaryTint1: '#524D6E',
  primaryTint2: '#706D87',
  primaryTint3: '#C3C0CD',
  primaryTint4: '#E1E0E6',
  secondary: '#A6A1E2',
  secondaryTint1: '#B8B4E8',
  secondaryTint2: '#CAC7EE',
  secondaryTint3: '#EFEEF7',
  secondaryTint4: '#F7F6FD',
  tertiary: '#F8F8FA',
  tertiaryTint1: '#F8F8FA',
  tertiaryTint2: '#F8F8FA',
  tertiaryTint3: '#F8F8FA',
  tertiaryTint4: '#F8F8FA',
  default: '#706D87',
  defaultLight: '#EDEDF0',
  defaultBorder: '#E1E0E6',
  success: '#2B6E33',
  successLight: '#EAF1EB',
  successBorder: '#DFE9E0',
  error: '#BD200F',
  errorLight: '#F7EAE8',
  errorBorder: '#F3DEDC',
  info: '#554CB3',
  infoLight: '#EEEDF7',
  infoBorder: '#E5E3F3',
  background: '#F8F8FA',
  backgroundDark: '#F8F8FA',
  overlay: 'rgba(45, 45, 48, 0.7)',
  overlaySolid: '#2D2D30',
  border: '#EDEDF0',
  textDisabled: '#C3C0CD',
  black: '#000000',
  white: '#FFFFFF',
  transparent: 'transparent'
};

export { PRIMARY_COLORS as default };
